<!-- Cart -->
<div
  id="ticket-details"
  class="md:flex md:flex-col md:justify-between w-full h-fit box-white">
  <div>
    <div class="box-header-center md:box-header">
      <div class="w-full md:text-left text-center">
        <h3 class="mb-1 font-bold">Your Ticket Details</h3>
        <p class="font-semibold text-gray-400">
          {{ transaction().transaction.event?.description }} -
          {{ transaction().transaction.event?.date | date: 'short' }}
        </p>
      </div>
    </div>
    <div class="md:m-2 box-body">
      @for (seat of seatsByPrice(); track $index) {
        <h4 class="font-bold text-main-dark md:text-left text-center">
          <span data-cy="cart-seats-quantity" class="underline">{{
            seat.quantity
          }}</span>
          Seats x
          <span data-cy="cart-buyer-type" class="underline">{{
            transaction().transaction.buyerTypeName
          }}</span>
          at
          <span class="text-red">${{ seat.price | number: '1.2-2' }}</span>
        </h4>
      }
      <div class="md:px-4 w-full">
        <table class="w-full border-separate table-fixed">
          @for (section of seatsForTable(); track section.id) {
            <tr class="flex flex-wrap md:flex-nowrap my-2 mb-3 md:mb-0">
              <td class="content-center mb-1 md:mb-0 w-full md:w-16 td">
                <div class="flex justify-center items-center">
                  <img
                    ngSrc="/assets/img/chair-blue-icon.svg"
                    alt="main chair icon"
                    width="12"
                    height="12"
                    [priority]="false"
                    class="mr-1" />
                  <p class="font-bold text-main text-center">
                    {{ section.totalSectionSeats }}
                  </p>
                </div>
              </td>
              <td
                class="flex justify-center md:mx-2 mb-1 md:mb-0 w-full md:w-min td">
                <p class="flex items-center text-center">
                  Section
                  <span class="ml-2 font-bold text-main">{{ section.id }}</span>
                </p>
              </td>
              <td class="p-0 w-full">
                @for (row of section.rows; track row.id) {
                  <div class="flex justify-start md:w-auto td-lines">
                    <p class="mr-10 md:mr-5 lg:mr-10">
                      Row<span class="ml-2 font-bold text-main">{{
                        row.id
                      }}</span>
                    </p>
                    <p>
                      Seats<span class="ml-2 font-bold text-main">{{
                        row.seatsRanges.join(', ')
                      }}</span>
                    </p>
                  </div>
                }
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  </div>
  <div class="flex justify-end items-center p-5 border-t border-t-gray-100">
    <h5 class="font-bold">
      @if (transaction().transaction.tdcTransaction?.totalPriceSeats) {
        Price: ${{
          transaction().transaction.tdcTransaction?.totalPriceSeats
            | number: '1.2-2'
        }}
      }
    </h5>
  </div>
</div>
